import script from "./DividerAnimated.vue?vue&type=script&setup=true&lang=js"
export * from "./DividerAnimated.vue?vue&type=script&setup=true&lang=js"

import "./DividerAnimated.vue?vue&type=style&index=0&id=20044e9e&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20044e9e"]])

export default __exports__